import { CreditCardType, PaymentMethod, SetupIntentResult } from './contracts';

export const paymentExtension = (provider: string, method: PaymentMethod, action: string) => `${provider}.${method}.${action}`;

export const PAYMENT_SELECTOR_PREFIX = `financial.selector`;

export const FRIENDLY_CREDIT_CARD_TYPES: Record<CreditCardType, string> = {
	[CreditCardType.Amex]: 'Amex',
	[CreditCardType.Discover]: 'Discover',
	[CreditCardType.Jcb]: 'JCB',
	[CreditCardType.Mastercard]: 'Mastercard',
	[CreditCardType.Other]: 'Other',
	[CreditCardType.UnionPay]: 'Union Pay',
	[CreditCardType.Unspecified]: 'Unspecified',
	[CreditCardType.Visa]: 'VISA'
} as const;

export const monthDictionary: Record<number, string> = {
	1: 'Jan',
	2: 'Feb',
	3: 'Mar',
	4: 'Apr',
	5: 'May',
	6: 'Jun',
	7: 'Jul',
	8: 'Aug',
	9: 'Sep',
	10: 'Oct',
	11: 'Nov',
	12: 'Dec'
};

export const FRIENDLY_PAYMENT_METHODS: Record<PaymentMethod, string> = {
	[PaymentMethod.CreditCard]: 'Credit Card',
	[PaymentMethod.DirectDebit]: 'Direct Debit',
	[PaymentMethod.Cash]: 'Cash',
	[PaymentMethod.Cheque]: 'Cheque',
	[PaymentMethod.Statement]: 'Statement',
	[PaymentMethod.PayrollDeduction]: 'Payroll deduction',
	[PaymentMethod.Generic]: 'Generic',
	[PaymentMethod.OneTimePayment]: 'One time payment'
};

export const DESIGN_MODE_INTENT: SetupIntentResult = {
	key: '123',
	error: null,
	intentId: '123',
	data: { timestamp: '123', fingerprint: '123', returnUrl: '' }
};
